import { Controller } from "@hotwired/stimulus"

// modified, but loosely resembling, https://www.youtube.com/watch?v=DS6DJjrvg5c
// Connects to data-controller="auto-save"
export default class extends Controller {

  connect() {
    this.form = this.element
    this.activeFetch = null
  }

  save(event) {
    // During development it's helpful to avoid sending concurrent requests to the server.
    if (rails_env == "development" && this.activeFetch != null) {
      // We're still waiting for the last save to happen.
      return;
    }

    this.mostRecentSave = event.timeStamp

    setTimeout(() => {
      if (this.mostRecentSave === event.timeStamp) {
        const formData = new FormData(this.form)

        this.activeFetch = fetch(this.form.action, {
          method: this.form.method,
          body: formData,
          headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
            "Accept": "text/vnd.turbo-stream.html",
          }
        }).then((response) => {
          // for now, we don't have to do anything when we save. in the future, maybe we make it obvious that it is saved
          this.activeFetch = null
        })
      } else {
        // there was a change within the timeout, so we don't save
      }
    }, 1000)
  }
}
